import { create } from 'zustand';

interface PermissionDeniedState {
  isOpen: boolean;
  permissionLabel: string;
  show: (permissionLabel: string) => void;
  close: () => void;
}

export const usePermissionDeniedStore = create<PermissionDeniedState>((set) => ({
  isOpen: false,
  permissionLabel: '',
  show: (permissionLabel) => set({ isOpen: true, permissionLabel }),
  close: () => set({ isOpen: false, permissionLabel: '' }),
}));
